import moment from 'moment';

import { useToast } from '@/context/ToastContext';

export const ErrorMessage: Record<string, Function> = {
  default: () => 'Ocorreu um erro inesperado, tente novamente mais tarde!',
  expiredToken: () => 'Sua sessão expirou!',
  invalidDate: () => 'Data inválida',
  minDate: (minDate: Date): string =>
    `A data minima aceita é ${moment(minDate).format('DD/MM/YYYY')}`,
  required: () => 'Campo obrigatório',
  invalid: () => 'Valor inválido',
  addressDefaultErro: () => 'Endereço não encontrado',
  invalidCredentials: () =>
    'Credenciais inválidas. Verifique se e-mail e senha foram informados corretamente.',
};

export const BACKEND_ERROR_MESSAGES: Record<string, string> = {
  'user with this email address already exists.':
    'Já existe um usuário com este endereço de e-mail.',
  'The entered phone number is not valid.': 'O número de telefone inserido não é válido.',
  'check out should occur after check in':
    'A data de check-out deve ser maior que a  data de check-in.',
  'Listing not found': 'Não foi encontrado um anúncio para este imóvel.',
  'Reservation already exists within this date': 'Já existe uma reserva nesta data.',
  'Ensure this field has no more than 11 characters.':
    'O campo CPF possui mais de 11 caracteres.',
  'User age must be over 12 and under 123 years.':
    'A idade do usuário deve estar entre 12 e 123 anos.',
  'The fields reservation, checklist must make a unique set.': 'Nenhum campo foi alterado',
  'This field may not be blank.': 'O campo não pode estar em branco.',
  'This field may not be null.':
    'O campo de Anfitrião responsável não foi preenchido corretamente.',
  'This field must be unique.': 'O e-mail deve ser diferente dos demais cadastrados.',
  'Ensure that there are no more than 2 decimal places':
    'Certifique-se de que não haja mais de 2 casas decimais',
  'The fields property, ota must make a unique set.':
    'Já existe listing para este imóvel nesta OTA',
  'File is not CSV type': 'O arquivo selecionado não é um CSV',
  'This property code already exists and is active':
    'Esse código de imóvel já existe e está ativo!',
  'This password is too common.': 'Esta senha é muito comum.',
  'This password is too short. It must contain at least 8 characters.':
    'Esta senha é muito curta. Deve conter pelo menos 8 caracteres',
  "Password fields didn't match.": 'Os campos de senha não correspondem.',
  'user with this pipedrive person id already exists.': 'Esse Person ID já está cadastrado.',
  'property has extra day preparation':
    'Não é possível inserir um bloqueio, pois o imóvel necessita de tempo de preparo antes e depois do período selecionado. Tente selecionar um novo período que respeite esse intervalo.',
  'partner with this user already exists.': 'Já existe um parceiro para este usuário.',
};

type ToastFunction = (errorFields: any, defaultMessage?: string) => void;

export const useToastErrorMessage = (): ToastFunction => {
  const toast = useToast();

  return (errorFields: any, defaultMessage?: string) => {
    if (errorFields?.detail && typeof errorFields.detail === 'object') {
      const flatError = (error: any): string[] => {
        if (typeof error !== 'object' || error === null) {
          return [String(error)];
        }

        const errors = Object.keys(error).map((key) => {
          const val = error[key];

          if (Array.isArray(val)) {
            const messages = val.map((element: any) => {
              if (typeof element === 'object' && element !== null) {
                return flatError(element);
              }

              return BACKEND_ERROR_MESSAGES[element] || element;
            });
            return messages;
          }

          if (typeof val === 'object' && val !== null) {
            return flatError(val);
          }
          return [String(val)];
        });

        return errors.flat(Infinity);
      };

      const result = flatError(errorFields.detail);
      toast.error(result);
      return;
    }

    toast.error(defaultMessage || ErrorMessage.default());
  };
};
